import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Events } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
import { onError } from "util/conditional/onError";
const fetchEvent = (eventId) => Events.getById(eventId).then((data) => data.event);
const useEventById = (eventId, { onErrorHandler } = {}) => {
  const { data, refetch, isLoading, isFetched } = useQuery({
    queryKey: ["event-by-id", eventId],
    queryFn: () => onError(fetchEvent(eventId), (errorThrown) => {
      if (onErrorHandler) onErrorHandler(errorThrown);
      UserNotification.error(
        `Loading event or alert failed with status: ${errorThrown}`,
        "Could not load event or alert"
      );
    }),
    placeholderData: keepPreviousData,
    enabled: !!eventId
  });
  return {
    data,
    refetch,
    isLoading,
    isFetched
  };
};
export default useEventById;
